'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFns = require('date-fns');

var popup = document.querySelector('.site-popup');

exports.default = {
  init: function init() {
    if (!popup || window.navigator && window.navigator.cookieEnabled === false) return;

    var cached = this.getCached();

    if (cached) {
      this.checkNoticeStatus(cached);
    } else {
      this.openPopup();
    }
  },
  getCached: function getCached() {
    return localStorage.getItem('matilda-site-popup');
  },
  setCache: function setCache() {
    localStorage.setItem('matilda-site-popup', Date.now());
  },
  openPopup: function openPopup() {
    var _this = this;

    var closeBtn = popup.querySelector('.site-popup-close');

    setTimeout(function () {
      popup.classList.add('show');
    }, 800);

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        _this.closePopup();
      });
    }
  },
  closePopup: function closePopup() {
    popup.classList.remove('show');
    this.setCache();
  },
  checkNoticeStatus: function checkNoticeStatus(timestamp) {
    var daysPassed = (0, _dateFns.differenceInDays)(Date.now(), parseInt(timestamp));

    if (daysPassed >= 7) {
      localStorage.removeItem('matilda-site-popup');
      this.openPopup();
    }
  }
};


// WEBPACK FOOTER //
// ./scripts/components/sitePopup.js